<script setup lang="ts">
    const { label, iconInverted = false } = defineProps<{
        label: string;
        iconInverted?: boolean;
    }>();

    const emit = defineEmits<{
        click: [];
    }>();

    const buttonRef = ref<HTMLButtonElement | null>(null);

    const focus = () => {
        buttonRef.value?.focus();
    };

    defineExpose({
        focus
    });
</script>

<template>
    <button
        ref="buttonRef"
        type="button"
        class="close-button"
        :class="{ '--icon-inverted': iconInverted }"
        @click="emit('click')"
    >
        <span class="sr-only">{{ label }}</span>
        <CloseIcon />
    </button>
</template>

<style scoped lang="scss">
    .close-button {
        display: inline-flex;

        &.--icon-inverted {
            color: $white;
        }
    }
</style>
